import React, { useEffect } from 'react';
import './About.css';
import AOS from 'aos';
import 'aos/dist/aos.css';

const About = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: false});
  }, []);
  return (
    <section id="about" className="about">
      <div className="about-container">
        <div className="about-text" data-aos="fade-right">
          <h2 data-aos="fade-down" data-aos-delay="100">About Me</h2>
          <p data-aos="fade-up" data-aos-delay="200">
            Hey Folks! I’m <strong>Rishabh Doshi</strong>, founder of <strong>R.D'S Creations</strong>. With a passion for storytelling through visuals, I specialize in capturing your best moments and transforming them into timeless memories.
          </p>
          <p data-aos="fade-up" data-aos-delay="300">
            From weddings and birthdays to corporate shoots and cinematic edits – I offer a complete solution for your photo and video needs. Let’s create something magical together!
          </p>
          <div
            className="about-tagline"
            style={{ textAlign: 'center', textTransform: 'uppercase', color: 'black' }}
            data-aos="zoom-in-up"
            data-aos-delay="400"
          >
            <p style={{ fontWeight: 'bold', fontSize: '20px' }}>
              Most People Do Things In The Same Way
            </p>
            <p style={{ fontWeight: 'bold', fontSize: '24px', margin: '10px 0' }}>
              BUT
            </p>
            <p style={{ fontWeight: 'bold', fontSize: '20px' }}>
              We Do The Same Things In A <span style={{ fontWeight: 'bold' }}>Different</span> Way.
            </p>
          </div>
        </div>
        <div className="about-image" data-aos="fade-left" data-aos-delay="500">
          <img
            src="/Images/WhatsApp Image 2025-04-05 at 00.47.56.jpeg"
            alt="Rishabh Doshi"
          />
        </div>
      </div>
    </section>
  );
};

export default About;